/* eslint-disable no-restricted-syntax */
export interface Size {
    width: number;
    height: number;
}

/**
 * 适配生图接口的尺寸要求, 计算符合要求的最佳尺寸
 *
 * 图片尺寸默认“1024X1024”；支持用户自定义尺寸，但输入尺寸只支持768-1280之间且为64的倍数的数字;
 */
export function convertImageSize({ width, height }: Size): Size {
    const minSize = 768;
    const maxSize = 1280;
    const step = 64;

    // 生成所有可能的尺寸
    const sizes: number[] = [];
    for (let i = minSize; i <= maxSize; i += step) {
        sizes.push(i);
    }

    const aspectRatio = width / height;
    let bestRatioDiff = Number.POSITIVE_INFINITY;
    let bestSizeList: Array<Size> = [];

    // 遍历所有可能的宽高组合
    for (const w of sizes) {
        for (const h of sizes) {
            const ratio = w / h;
            const diff = Math.abs(aspectRatio - ratio);
            if (diff === bestRatioDiff) {
                bestSizeList.push({ width: w, height: h });
            } else if (diff < bestRatioDiff) {
                bestSizeList = [{ width: w, height: h }];
                bestRatioDiff = diff;
            }
        }
    }

    if (bestSizeList.length === 1) return bestSizeList[0];

    let bestSizeDiff = Number.POSITIVE_INFINITY;
    // eslint-disable-next-line prefer-destructuring
    let bestSize: Size = bestSizeList[0];
    for (const size of bestSizeList) {
        const sizeDiff = Math.abs(size.width - width) + Math.abs(size.height - height);
        if (sizeDiff < bestSizeDiff) {
            bestSizeDiff = sizeDiff;
            bestSize = size;
        }
    }

    return bestSize;
}
